import { Trans, useTranslation } from 'react-i18next';

import { Button, Dialog, ExternalLink, Text } from '~/components';

type Props = {
  onConfirm: () => void;
  onGoBack: () => void;
};

export const RequestAddressChangeDialog = ({ onConfirm, onGoBack }: Props) => {
  const { t } = useTranslation(['settings']);

  return (
    <Dialog.Root disablePointerDismissal open>
      <Dialog.Body>
        <Dialog.Header
          description={t('settings:prompts.verifyAddress.change.description')}
          hideCloseButton
          title={t('settings:prompts.verifyAddress.change.title')}
        />

        <Text>
          <Trans
            components={{ myEnterpriseLink: <ExternalLink href="https://www.myenterprise.be/" /> }}
            i18nKey="settings:prompts.verifyAddress.change.kboMessage"
          />
        </Text>

        <Dialog.Actions>
          <Button emphasis="secondary" onClick={onGoBack}>
            {t('settings:prompts.verifyAddress.change.actions.back')}
          </Button>

          <Button
            onClick={() => {
              window.open(t('settings:prompts.verifyAddress.change.mailLink'), '_blank');
              onConfirm();
            }}
          >
            {t('settings:prompts.verifyAddress.change.actions.mail')}
          </Button>
        </Dialog.Actions>
      </Dialog.Body>
    </Dialog.Root>
  );
};
